<div class="w-full h-full p-2 flex flex-col gap-4">
    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.InfringementRegenerationTitle' | translate }}</div>
        <hr>
        <div>
            <p>{{ 'AdminPanel.RegenerateInfringementsForSubcompanies' | translate }}</p>
            <button *ngIf="!loading" class="bg-tachosafe-500 px-2 py-1 text-white text-center"
                (click)="regenerateInfringements()">{{ 'AdminPanel.Regenerate' | translate }}</button>
            <div class="animate-spin w-min m-6" *ngIf="loading">{{ 'AdminPanel.Loading' | translate }}</div>
        </div>
        <div>
            <p>
                {{ 'AdminPanel.Status' | translate }}
            </p>
            <div *ngIf="currentTaskInQueue>0" class="flex flex-col ">
                <div>{{ 'AdminPanel.RegeneratingDriversRemaining' | translate:{ count: currentTaskInQueue } }}</div>
                <button class="bg-tachosafe-500 px-2 py-1 text-white text-center"
                    (click)="cancelRegenerateInfringements()">{{ 'AdminPanel.Cancel' | translate }}</button>
            </div>
            <div *ngIf="currentTaskInQueue==0">
                {{ 'AdminPanel.NoActiveRegeneration' | translate }}
            </div>
        </div>
    </div>


    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.CalculateBilling' | translate }}</div>
        <hr>
        <div class="flex flex-row flex-wrap items-end gap-2">
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.Year' | translate }}</div>
                <input type="number" [(ngModel)]="billingYear" class="border border-gray-300 p-1 rounded-md">
            </div>
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.Quarter' | translate }}</div>
                <input type="number" [(ngModel)]="billingQuarter" class="border border-gray-300 p-1 rounded-md">
            </div>
            <button class="bg-tachosafe-500 h-9 px-2 py-1 text-white text-center" (click)="calculateBilling()">{{
                'AdminPanel.Calculate' | translate }}</button>
        </div>

    </div>

    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.ReloadDataForFile' | translate }}</div>
        <hr>
        <div class="flex flex-row flex-wrap items-end gap-2">
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.Hash' | translate }}</div>
                <input [(ngModel)]="reloadFileHash" class="border border-gray-300 p-1 rounded-md">
            </div>
            <button class="bg-tachosafe-500 h-9 px-2 py-1 text-white text-center" (click)="reloadDataForFile()">{{
                'AdminPanel.Reload' | translate }}</button>
        </div>

    </div>

    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.ReactivateNotPayingClient' | translate }}</div>
        <hr>
        <div class="flex flex-row flex-wrap items-end gap-2">
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.ClientId' | translate }}</div>
                <p-dropdown [virtualScroll]="true" [itemSize]="30" [options]="availableCompanies"
                    [(ngModel)]="selectedReactivateCompany" optionLabel="name" [filter]="true" filterBy="name"
                    [showClear]="true" placeholder="{{ 'Topbar.SelectCompany' | translate }}">
                    <ng-template pTemplate="selectedItem">
                        <div class="flex flex-row items-center gap-2 w-64" *ngIf="selectedReactivateCompany">
                            <div>{{ selectedReactivateCompany.name }}</div>
                        </div>
                    </ng-template>
                    <ng-template let-company pTemplate="item">
                        <div class="flex flex-row items-center gap-2 w-64">
                            <div>{{ company.name }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <button class="bg-tachosafe-500 h-9 px-2 py-1 text-white text-center"
                [disabled]="!selectedReactivateCompany" (click)="reactivateNotPayingClient()">{{ 'AdminPanel.Reactivate'
                | translate }}</button>
        </div>
    </div>

    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.ResendActivationEmail' | translate }}</div>
        <hr>
        <div class="flex flex-row flex-wrap items-end gap-2">
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.Username' | translate }}</div>
                <input [(ngModel)]="resendActivationEmailUname" class="border border-gray-300 p-1 rounded-md">
            </div>
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.EmailAddress' | translate }}</div>
                <input [(ngModel)]="resendActivationEmailEmail" class="border border-gray-300 p-1 rounded-md">
            </div>
            <button class="bg-tachosafe-500 h-9 px-2 py-1 text-white text-center" (click)="resendActivationEmail()">{{
                'AdminPanel.Resend' | translate }}</button>
        </div>
    </div>

    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.GetDriverCompanyNames' | translate }}</div>
        <hr>
        <div class="flex flex-row flex-wrap items-end gap-2">
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.DriverId' | translate }}</div>
                <input [(ngModel)]="driverLookupDriverId" class="border border-gray-300 p-1 rounded-md">
            </div>
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.CardNumber' | translate }}</div>
                <input [(ngModel)]="driverLookupCardNumber" class="border border-gray-300 p-1 rounded-md">
            </div>
            <button class="bg-tachosafe-500 h-9 px-2 py-1 text-white text-center"
                [disabled]="!canQueryDriverCompanies()" (click)="queryDriverCompanies()">{{
                'AdminPanel.QueryDriverCompanies' | translate }}</button>

        </div>
        <div *ngIf="driverCompaniesError" class="text-red-600">{{driverCompaniesError}}</div>
        <div *ngIf="driverCompaniesResult" class="text-sm">
            <div class="font-semibold">{{ 'AdminPanel.Companies' | translate }}</div>
            <div>{{driverCompaniesResult}}</div>
        </div>
    </div>

    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.GetVehicleCompanyNames' | translate }}</div>
        <hr>
        <div class="flex flex-row flex-wrap items-end gap-2">
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.VehicleId' | translate }}</div>
                <input [(ngModel)]="vehicleLookupVehicleId" class="border border-gray-300 p-1 rounded-md">
            </div>
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.Vin' | translate }}</div>
                <input [(ngModel)]="vehicleLookupVin" class="border border-gray-300 p-1 rounded-md">
            </div>
            <button class="bg-tachosafe-500 h-9 px-2 py-1 text-white text-center"
                [disabled]="!canQueryVehicleCompanies()" (click)="queryVehicleCompanies()">{{
                'AdminPanel.QueryVehicleCompanies' | translate }}</button>
        </div>
        <div *ngIf="vehicleCompaniesError" class="text-red-600">{{vehicleCompaniesError}}</div>
        <div *ngIf="vehicleCompaniesResult" class="text-sm">
            <div class="font-semibold">{{ 'AdminPanel.Companies' | translate }}</div>
            <div>{{vehicleCompaniesResult}}</div>
        </div>
    </div>

    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'AdminPanel.GetDeviceInfos' | translate }}</div>
        <hr>
        <div class="flex flex-row flex-wrap items-end gap-2">
            <div class="flex flex-col gap-1">
                <div>{{ 'AdminPanel.Imei' | translate }}</div>
                <input [(ngModel)]="deviceLookupImei" class="border border-gray-300 p-1 rounded-md">
            </div>
            <button class="bg-tachosafe-500 h-9 px-2 py-1 text-white text-center" [disabled]="!canQueryDeviceInfos()"
                (click)="queryDeviceInfos()">{{ 'AdminPanel.QueryDeviceInfos' | translate }}</button>
        </div>
        <div *ngIf="deviceInfosError" class="text-red-600">{{deviceInfosError}}</div>
        <div *ngIf="deviceInfosResult" class="text-sm">
            <div class="font-semibold">{{ 'AdminPanel.Device' | translate }}</div>
            <div>{{deviceInfosResult}}</div>
        </div>
    </div>
</div>